import PageNotFound from "page-components/error-states/404"

export default PageNotFound
